import React, { useEffect, useState } from 'react'
import "./UwDbMovement.scss";
import { useSelector } from 'react-redux';
import newRequest from '../../../utils/newRequest';
import ConfirmDialog from '../../../components/confirmDialog/confirmDialog';
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Paper,
} from "@mui/material";
import { motion } from "framer-motion";
import { GridLoader, ScaleLoader } from "react-spinners";
import { CustomLoadingButton } from '../../../components/ui/CustomButton';
import numeral from "numeral";
import ExpandableComponent from '../../../components/expandableComponent/ExpandableComponent';
import { useTranslation } from "react-i18next";

const UwDbMovement = ({ death_benefit, factor, start_year, interest_rate, term_death_level, term_years, from_date }) => {
    const { currentTheme } = useSelector((state) => state.theme);
    const { t } = useTranslation();
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");
    const [isLoading, setIsLoading] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [movement, setMovement] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [currentMovementPage, setCurrentMovementPage] = useState(0);
    const [objectToAction, setObjectToAction] = useState({
        object_id: "",
        action_text: "",
        action_invoked: "",
    });

    const handleMovementsPageChange = (event, newPage) => {
        setCurrentMovementPage(newPage);
    };


    const handleConfirm = async () => {
        try {
            if (confirmDialogAction === "deleteNumGen") {

            }
        } catch (err) {
            console.log(err);
        }
        // Close the dialog
        setIsConfirmDialogOpen(false);
    };

    const handleCancel = () => {
        setIsConfirmDialogOpen(false);
    };

    const handleCloseNotifyDialog = () => {
        setIsNotifyDialogOpen(false);
    };

    const fetchMovement = async () => {
        try {
            // console.log(`death_benefit : ${death_benefit}\nterm_years : ${term_years}\nfactor : ${factor}\nstart_year : ${start_year}\nmode: ${term_death_level?.split("-")[0]}\ncalc_method : ${term_death_level?.split("-")[1]}\ninterest_rate :${interest_rate}`)
            if (term_death_level !== "level") {
                const res = await newRequest.post("/uwMortality/getAdjustement", {
                    death_benefit,
                    term: term_years,
                    factor,
                    start_year,
                    mode: term_death_level?.split("-")[0],
                    calc_method: term_death_level?.split("-")[1],
                    interest_rate,
                    from_date
                });
                console.log(`fetchMovement ${JSON.stringify(res.data, null, 2)}`);
                setMovement(res.data);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    useEffect(() => {
        fetchMovement();
    }, []);

    const normalizedData = normalizeData(movement);
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    return (
        <div className="db-movement">
            {isLoading ? (
                <div className="no-content"
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "100%",
                        height: "100%",
                    }}
                >
                    <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
                </div>
            ) : (
                <div className="db-movement-main-wrapper">
                    <div className="grid-container">
                        {normalizedData?.map((row, index) => (
                            <ExpandableComponent
                                key={row.year}
                                title={`YEAR ${row.year}`}
                                subtitle={index + 1}
                                defaultExpanded={false}
                            >
                                <div className="months-grid">
                                    {row.months?.map((month, monthIndex) => {
                                        // Determine the correct class based on multiple conditions
                                        let cardClass = 'normal'; // Default class

                                        if (month.beginning_value === 0 && month.ending_death_benefit === 0) {
                                            cardClass = 'zero';
                                        } else if (month.beginning_value === death_benefit) {
                                            cardClass = 'opening';
                                        } else if (month.ending_death_benefit === 0 && month.beginning_value > 0) {
                                            cardClass = 'closing';
                                        }

                                        return (
                                            <div
                                                key={monthIndex}
                                                className={`month-card ${cardClass}`}
                                            >
                                                <h4>{monthNames[monthIndex]}</h4>
                                                <p>{`Opening: ${numeral(month.beginning_value || 0).format("0,0.00")}`}</p>
                                                <p>{`Adj Factor: ${numeral(month.adjustment_factor || 0).format("0,0.00")}%`}</p>
                                                <p>{`Adj Amount: ${numeral(month.adjustment_amount || 0).format("0,0.00")}`}</p>
                                                <p>{`Closing: ${numeral(month.ending_death_benefit || 0).format("0,0.00")}`}</p>
                                            </div>
                                        );
                                    })}
                                </div>
                            </ExpandableComponent>
                            // <Paper
                            //     key={row.year}
                            //     className={`grid-year ${selectedRow?.year === row.year ? 'selected' : ''}`}
                            //     onClick={() => setSelectedRow(row)}
                            //     elevation={0.5}
                            //     style={{ padding: '16px', marginBottom: '16px', cursor: 'pointer' }}
                            // >
                            //     <h3 className="year-title">Year: {row.year}</h3>
                            //     <div className="months-grid">
                            //         {row.months?.map((month, monthIndex) => {
                            //             // Determine the correct class based on multiple conditions
                            //             let cardClass = 'normal'; // Default class

                            //             if (month.beginning_value === 0 && month.ending_death_benefit === 0) {
                            //                 cardClass = 'zero';
                            //             } else if (month.beginning_value === death_benefit) {
                            //                 cardClass = 'opening';
                            //             } else if (month.ending_death_benefit === 0 && month.beginning_value > 0) {
                            //                 cardClass = 'closing';
                            //             }

                            //             return (
                            //                 <div
                            //                     key={monthIndex}
                            //                     className={`month-card ${cardClass}`}
                            //                 >
                            //                     <h4>{monthNames[monthIndex]}</h4>
                            //                     <p>{`Opening: ${numeral(month.beginning_value || 0).format("0,0.00")}`}</p>
                            //                     <p>{`Adj Factor: ${numeral(month.adjustment_factor || 0).format("0,0.00")}%`}</p>
                            //                     <p>{`Adj Amount: ${numeral(month.adjustment_amount || 0).format("0,0.00")}`}</p>
                            //                     <p>{`Closing: ${numeral(month.ending_death_benefit || 0).format("0,0.00")}`}</p>
                            //                 </div>
                            //             );
                            //         })}
                            //     </div>
                            // </Paper>
                        ))}
                    </div>
                </div>
            )}

            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={handleCloseNotifyDialog}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton onClick={handleCloseNotifyDialog}>{t('close')}</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={handleCancel}
                onConfirm={handleConfirm}
                dialogTitle="Confirmation"
                dialogContent={<p>{objectToAction.action_text}</p>}
            />
            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <GridLoader
                            color="#F44336"
                            style={{
                                height: "50px",
                                width: "50px",
                            }}
                        />
                    </div>
                </motion.div>
            )}
        </div>
    );
}

const normalizeData = (data) => {
    return data?.map((yearObj) => {
        // Create an array of 12 months, filling missing months with zeroed values
        const months = new Array(12).fill({
            beginning_value: 0,
            adjustment_factor: 0,
            adjustment_amount: 0,
            ending_death_benefit: 0,
        });

        yearObj?.months?.forEach(monthObj => {
            months[monthObj.month - 1] = monthObj;  // Place the month data in the correct index (month - 1)
        });

        return {
            year: yearObj.year,
            months
        };
    });
};

export default UwDbMovement